<template>
    <main class="pd-main">
      <div class="main-content">
        <circle-spin class="m-0" v-if="firstLoad"></circle-spin>
        <div v-else>
            <div class="row"> 
                <div class="col-lg-6">
                    <div class="card">
                        <h4 class="card-title"><strong>ISSUES</strong></h4>
                        <div class="card-body">
                          <v-client-table :columns="column1" :data="data1" :options="option1"> 
                                  <div slot="id" slot-scope="props" >{{props.index}}</div>
                                  <div slot="actions" slot-scope="props">
                                    <nav class="flexbox fs-16">
                                      <a href="#" @click="delAction({id:props.row.id, type: 'issue'})" data-provide="tooltip" data-original-title="Delete">
                                        <span class="btn btn-sm btn-danger icon ion-android-delete"></span>
                                      </a>
                                    </nav>
                                  </div>
                          </v-client-table>
                        </div>
                        <div class="card-body">
                          <div v-if="!open_issue">
                            <div>
                                <a class="btn btn-sm btn-round btn-primary" href="#" @click="openIssueForm">Add New Issues</a>
                            </div>
                          </div>
                          <div v-else>
                                <div class="form-group">
                                  <label>List of Issues  <small>** Seperate by commas</small></label>
                                  <input class="form-control" type="text" id="issue" @blur="$v.issue.$touch()" v-model="issue"/>
                                  <div v-if="$v.issue.$dirty">
                                      <div class="custom-error" v-if="!$v.issue.required">*At least one issue is required.</div>
                                  </div> 
                                </div>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" disabled v-if="loadIssue">
                                  <circle-spin class="m-0"></circle-spin>
                                </button>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" href="#" v-else @click="addIssue" type="button">Add</button>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="card">
                        <h4 class="card-title"><strong>LANGUAGES</strong></h4>
                        <div class="card-body">
                          <v-client-table :columns="column2" :data="data2" :options="option2"> 
                                  <div slot="id" slot-scope="props" >{{props.index}}</div>
                                  <div slot="actions" slot-scope="props">
                                    <nav class="flexbox fs-16">
                                      <a href="#" @click="delAction({id:props.row.id, type: 'language'})" data-provide="tooltip" data-original-title="Delete">
                                        <span class="btn btn-sm btn-danger icon ion-android-delete"></span>
                                      </a>
                                    </nav>
                                  </div>
                          </v-client-table>
                        </div>
                        <div class="card-body">
                            <div v-if="!open_language">
                              <div>
                                <a class="btn btn-sm btn-round btn-primary" href="#" @click="openLanguageForm">Add New Languages</a>
                              </div>
                            </div>
                            <div v-else>
                                <div class="form-group">
                                  <label>List of Languages  <small>** Seperate by commas</small></label>
                                  <input class="form-control" type="text" id="language" @blur="$v.language.$touch()" v-model="language"/>
                                  <div v-if="$v.language.$dirty">
                                      <div class="custom-error" v-if="!$v.language.required">*At least one language is required.</div>
                                  </div>
                                </div>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" disabled v-if="loadLanguage">
                                  <circle-spin class="m-0"></circle-spin>
                                </button>
                                <button class="mb-10 btn btn-sm btn-bold btn-primary" href="#" v-else @click="addLanguage" type="button">Add</button>
                            </div>
                          </div>    
                    </div>
                </div>
            </div>
            <div>
              <div class="card">
                <h4 class="card-title"><strong>IMAGE CATALOGUE</strong></h4>
                  <div class="card-body">
                    <p v-if="avatars.length < 1">No Images in Catalogue.</p>
                    <div v-else class="flex justify-content-start mb-20">
                      <span v-for="(avatar, i) in avatars" :key="i">
                        <img class="avatar b-1 border-primary mr-10" :src="avatar.secure_url" alt="..." />
                      </span>
                    </div>
                    <p>Add images for listeners and members to choose from when selecting profile pictures.</p>
                    <input @change="imageSelected" type="file"  ref="image">
                    <div class="mt-10">
                      <button class="mb-10 btn btn-sm btn-bold btn-primary" disabled v-if="loadAvatar">
                        <circle-spin class="m-0"></circle-spin>
                      </button>
                      <button class="mb-10 btn btn-sm btn-bold btn-primary" href="#" v-else @click="addAvatar" type="button">Add</button>
                    </div>
                      
                  </div>
              </div>
            </div>
        </div>

        <!-- Modal for delete -->
            <modal name="delete-action" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                    <div class="callout callout-error py-10 px-0 mb-0" role="alert">
                        <span class="close mr-10" @click="hideDeleteModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                        <h5 class="text-capitalize">Delete {{type}}</h5>
                        <div class="p-10">
                            <p>Are you sure you want to delete this {{type}}?</p>
                            <button class="btn btn-bold btn-sm btn-danger" disabled v-if="load_delete">
                                <circle-spin class="m-0"></circle-spin>
                            </button>
                            <button class="btn btn-bold btn-sm btn-danger" v-else type="button" @click="deleteAction">Delete</button>
                        </div>
                    </div>
                </div> 
            </modal>
      </div>
    </main>
</template>

<script>
import axios from 'axios'
import {
  required
} from "vuelidate/lib/validators";

export default {
    data() {
        return {
            open_issue: false,
            open_language: false,
            firstLoad: true,
            loadIssue: false,
            loadLanguage: false,
            loadAvatar: false,
            issue:"",
            language: "",
            // images: [],
            image: null,
            avatars: [],
            column1: ["id", "title", 'actions'],
            data1: [],
            option1: {
              headings: {
                id: "S/N",
                title: "Issue",
                actions: "Actions"
              },
              sortable: ["title"],
              filterable: ["title"]
            },
            column2: ["id", "name", 'actions'],
            data2: [],
            option2: {
              headings: {
                id: "S/N",
                name: "Language",
                actions: "Actions"
              },
              sortable: ["name"],
              filterable: ["name"]
            },
            load_delete: false,
            id: null,
            type: ''
        }
    },
    validations: {
      issue: { required },
      language: { required },
    },
    methods: {
        openIssueForm() {
            this.open_issue = true
        },
        openLanguageForm() {
            this.open_language = true
        },
        addIssue() {
          this.loadIssue = true
          let userData = {
            data: []
          }
          let issues_list = this.issue.split(',')
          for(let i=0; i< issues_list.length; i++) {
            userData.data.push({title: issues_list[i]})
          }
          // console.log(userData)
          axios.post('/admin/add?type=issue', userData)
          .then(res => {
              this.loadIssue = false;
              this.$notify({
                group: 'response',
                type: 'success',
                title: 'Successfully added new issues',
                duration: 2500,
                ignoreDuplicates: true
              });
              setTimeout(() => {
                location.reload()
              }, 3000)
            })
            .catch(err => {
              this.loadIssue = false;
              this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000,
                ignoreDuplicates: true
              });
            })
        },
        addLanguage() {
          this.loadLanguage = true
          let userData = {
            data: []
          }
          let languages_list = this.language.split(',')
          for(let i=0; i< languages_list.length; i++) {
            userData.data.push({name: languages_list[i]})
          }
          // console.log(userData)
            axios.post('/admin/add?type=language', userData)
            .then(res => {
              this.loadLanguage = false;
              this.$notify({
                group: 'response',
                type: 'success',
                title: 'Successfully added new languages',
                duration: 2500,
                ignoreDuplicates: true
              });
              setTimeout(() => {
                location.reload()
              }, 3000)
            })
            .catch(err => {
              this.loadLanguage = false;
              this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000,
                ignoreDuplicates: true
              });
            })
        },
        imageSelected(event) {
          this.image = event.target.files[0];
        },
        addAvatar() {
          this.loadAvatar = true;
          const formData = new FormData()
          // for( var i = 0; i < this.images.length; i++ ){
            // formData.append("image", this.images[i]);
            formData.append("image", this.image);
          // }
          axios.post('/users/avatar', formData)
          .then(res => {
            this.loadAvatar = false;
              this.$notify({
                    group: 'response',
                    type: 'success',
                    title: 'Avatar uploaded successfully',
                    duration: 2500
              })
              setTimeout(() => {
                location.reload()
              }, 3000)
          })
          .catch(err => {
            // console.log(err)
            this.loadAvatar = false;
              this.$notify({
                    group: 'response',
                    type: 'error',
                    title:  `${err.response.data.message}`,
                    duration: 5000
              });
          })
        },
        delAction(payload) {
          this.id = payload.id
          this.type = payload.type
          this.$modal.show("delete-action");
        },
        hideDeleteModal(a) {
            a.hide('delete-action')
        },
        deleteAction() {
          this.load_delete = true
          if(this.type == 'issue'){
              axios.delete(`/admin/delete?type=issue&id=${this.id}`)
                .then(res => {
                    this.load_delete = false
                        this.$notify({
                            group: 'response',
                            type: 'success',
                            text: 'Successfully deleted.',
                            duration: 2500,
                        })
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                })
                .catch(err => {
                    this.load_delete= false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
          }
          else {
            axios.delete(`/admin/delete?type=language&id=${this.id}`)
                .then(res => {
                    this.load_delete = false
                        this.$notify({
                            group: 'response',
                            type: 'success',
                            text: 'Successfully deleted.',
                            duration: 2500,
                        })
                        setTimeout(() => {
                            location.reload()
                        }, 3000)
                })
                .catch(err => {
                    this.load_delete= false
                    this.$notify({
                        group: 'response',
                        type: 'error',
                        text:  `${err.response.data.message}`,
                        duration: 5000,
                    });
                })
          }
        }
    },
    mounted() {
        axios.get("/admin/list?type=issue")
        .then(res => {
          this.data1 = res.data.data
          axios.get("/admin/list?type=language")
          .then(res => {
            this.data2 = res.data.data
            axios.get('/users/avatars/all')
            .then(res => {
              this.firstLoad = false;
              this.avatars = res.data.results
            })
            .catch(err => {
              this.firstLoad = false;
              this.$notify({
                    group: 'response',
                    type: 'error',
                    title:  `${err.response.data.message}`,
                    duration: 5000
              });
            })
          })
          .catch(err => {
                this.firstLoad = false;
                this.$notify({
                    group: 'response',
                    type: 'error',
                    title:  `${err.response.data.message}`,
                    duration: 5000
                });
          })
        })
        .catch(err => {
            this.firstLoad = false;
            this.$notify({
                group: 'response',
                type: 'error',
                title:  `${err.response.data.message}`,
                duration: 5000
            });
        })
    }
}
</script>
